import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'nullIfZero',
})
export class NullIfZeroPipe implements PipeTransform {
  transform(value: number | null | undefined): number | null {
    return value ? value : null;
  }
}
